import { NetworkType } from "@/config";

const AccessControlManagerDev = "0x87D3440372293aCf9149552546F7141AAe05Be91";
const TokenRegistryDev = "0x1aD34aF0eac1cb6B60D93594c9d3F6A0a46bd2f9";
const ProviderRegistryDev = "0x038Eb8E227B287d7D42Cf404A07ACb5a7Df7645A";
const ProviderAttributeRegistryDev =
  "0x63942fCb221aDF85ebdFc11a061D5eea2384f00A";
const FizzRegistryDev = "0x6cB3604EeA7Ba303bB1a020fD8e06f034D5534a3";
const FizzAttributeRegistryDev = "0xB598170D89046385C62F10670CAe2658f6D8E7D7";
const TreasuryDev = "0xA05d173F369263fB697e1a0e214b107b59237400";
// const EscrowUserDev = '0x9859D327a776720DA084397693E53C483CCA0d77';
const EscrowDev = "0xb8AC4512852409C9b30F10844c3F0a61679fAe66";
const EscrowProtocolDev = "0xbEDE87cE3411F280B3Ed63027B45f73Cbcd1B441";
const OrderRequestDev = "0xCe9787883b8f3785CCd8C8c3275B5F41068d670A";
const ResourceManagerDev = "0x270d622149F46fFc72A9fD5A8cF92D1FdE5AD5E0";
const ComputeLeaseDev = "0x70008e46550E628D50310330686A0bc692F722Fd";
const BidDev = "0xe029A4f5e970c389Ca16e48600707496602af5Ed";
const ResourceRegistryCPUDev = "0x67B8c2201Eef00d1a8193a2aF301312DD21a286B";
const ResourceRegistryGPUDev = "0x2B73F279044347A3B6c9F122Ec6b479b6C2beAc9";
const ResourceRegistryFactoryDev = "0xbb132eB1b36D87ef7Ac63c95c05a8a56eCDac3fd";
const ProviderRewardsManagerDev = "0xe32279Bf9d47E20AEbb9ec04Ba5FB46536BA2aB5";
const FizzRewardsManagerDev = "0xd653644FFD4ec06d173237FbA952C450A4973f5c";
const RewardTokenDev = "0xB28aA1E5074AE0222cf764e2934182775Ee7AB42";
const FizzNodeRewardTokenDev = "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";

// Tokens addresses
const USDTDev = "0x96Ca5955F25648FB44C5D772BAdB4313000C66Fe";
const USDCDev = "0x816413630c39780677E1584D4a6DbAFd76b161F7";
const DAIDev = "0xcF5F08686dBE94B88b93FB2E8E5482A7f432C892";
const WETHDev = "0xd74C08f8ffDF88C807367813Ad64a960618f4dcC";
const CSTDev = "0x8E5996A3963011Ca9dFa04E3CB773147F98C0e17";
const SPONDev = "0x76e593392523243ACD38ceD87c2007F14483a86B";
const uSPONDev = "0xeD8F325cDc2BA7567395cb451A2ea8FAf40E23D2";

// MAINNET CONTRACTS
const TokenRegistryMainnet = "0xDCD3eeE9f5Fb828C4EaE14B8Fe2382c0dDD6de01";
const AccessControlManagerMainnet =
  "0x2F6dE416a7AEED365bE49DeB931D263EC742605C";
const ProviderRegistryMainnet = "0x79c892AE9D910bBeb81705960BA01706Bb2Af02e";
const ProviderAttributeRegistryMainnet =
  "0x4149Ff1496AA74F7A59989eb5332946fEed22705";
const FizzRegistryMainnet = "0x1071F508b68E9cf8f338170295C952BDF509AE4D";
const FizzAttributeRegistryMainnet =
  "0xB7AbA489Fe9F0eB930b8d298eD5FE669611cbf79";
const EscrowMainnet = "0x67Ad502B202Ac602C215B2Ba28689a71d03F9Ba4";
const EscrowProtocolMainnet = "0x7381F084D31EF2F983c95572b7DD6Ee99eE03d8d";
const OrderRequestMainnet = "0xC1A0AF3224465c2a5099C14c5A1A4f6680C30A86";
const ResourceManagerMainnet = "0x270d622149F46fFc72A9fD5A8cF92D1FdE5AD5E0";
const ComputeLeaseMainnet = "0x8A9f22D855bBE978C0D47De0963a3B15022E8ce0";
const BidMainnet = "0x1582D6f9A7098B112dC76dd55a98d11d95f4702A";
const ResourceRegistryCPUMainnet = "0x8Ac7BD17fA6E51E9719FaEfD8FD8Cc46ECAa93A9";
const ResourceRegistryGPUMainnet = "0x360135261AB6CF9c9bBeF4c5d2B1fB9bb1671C8e";
const ResourceRegistryFactoryMainnet =
  "0xF302Af7f042A6D2e6A4c1fF67e4f69109d8f4Fa0";
const ProviderRewardsManagerMainnet =
  "0x20f2159b1082529089752Bce0549a649B0f0032C";
const FizzRewardsManagerMainnet = "0x8A01206Fd078Be34b28d689C92C1f2C05B3C641B";
const RewardTokenMainnet = "0xA0c5ba7d9eccbE59000e8E67654CA5d867C6b401";
const FizzNodeRewardTokenMainnet = "0xA2400EFe3d7a9E2281F32A66Df18CFFE651c69f3";
const USDTMainnet = "0xF981a6AB8D09a636EC78395b02B1aC693a0C8307";
const USDCMainnet = "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913";
const uSPONMainnet = "0xBf0fA0461331d815A103e59929E5a19A48C30f5e";
const SPONMainnet = "0x080D43c2164AFdBc3712422CE78Ab902ccaB5CA1";

type ContractAddresses = {
  accessControlManager: string;
  tokenRegistry: string;
  providerRegistry: string;
  providerAttributeRegistry: string;
  fizzRegistry: string;
  fizzAttributeRegistry: string;
  escrow: string;
  escrowProtocol: string;
  orderRequest: string;
  resourceManager: string;
  computeLease: string;
  bid: string;
  resourceRegistryCPU: string;
  resourceRegistryGPU: string;
  resourceRegistryFactory: string;
  providerRewardsManager: string;
  fizzRewardsManager: string;
  rewardToken: string;
  fizzNodeRewardToken: string;
  usdt: string;
  usdc: string;
  dai?: string;
  weth?: string;
  cst?: string;
  spon: string;
  uspon: string;
};

export const addressMap: Record<NetworkType, ContractAddresses> = {
  testnet: {
    accessControlManager: AccessControlManagerDev,
    tokenRegistry: TokenRegistryDev,
    providerRegistry: ProviderRegistryDev,
    providerAttributeRegistry: ProviderAttributeRegistryDev,
    fizzRegistry: FizzRegistryDev,
    fizzAttributeRegistry: FizzAttributeRegistryDev,
    escrow: EscrowDev,
    escrowProtocol: EscrowProtocolDev,
    orderRequest: OrderRequestDev,
    resourceManager: ResourceManagerDev,
    computeLease: ComputeLeaseDev,
    bid: BidDev,
    resourceRegistryCPU: ResourceRegistryCPUDev,
    resourceRegistryGPU: ResourceRegistryGPUDev,
    resourceRegistryFactory: ResourceRegistryFactoryDev,
    providerRewardsManager: ProviderRewardsManagerDev,
    fizzRewardsManager: FizzRewardsManagerDev,
    rewardToken: RewardTokenDev,
    fizzNodeRewardToken: FizzNodeRewardTokenDev,
    usdt: USDTDev,
    usdc: USDCDev,
    dai: DAIDev,
    weth: WETHDev,
    cst: CSTDev,
    spon: SPONDev,
    uspon: uSPONDev,
  },
  mainnet: {
    accessControlManager: AccessControlManagerMainnet,
    tokenRegistry: TokenRegistryMainnet,
    providerRegistry: ProviderRegistryMainnet,
    providerAttributeRegistry: ProviderAttributeRegistryMainnet,
    fizzRegistry: FizzRegistryMainnet,
    fizzAttributeRegistry: FizzAttributeRegistryMainnet,
    escrow: EscrowMainnet,
    escrowProtocol: EscrowProtocolMainnet,
    orderRequest: OrderRequestMainnet,
    resourceManager: ResourceManagerMainnet,
    computeLease: ComputeLeaseMainnet,
    bid: BidMainnet,
    resourceRegistryCPU: ResourceRegistryCPUMainnet,
    resourceRegistryGPU: ResourceRegistryGPUMainnet,
    resourceRegistryFactory: ResourceRegistryFactoryMainnet,
    providerRewardsManager: ProviderRewardsManagerMainnet,
    fizzRewardsManager: FizzRewardsManagerMainnet,
    rewardToken: RewardTokenMainnet,
    fizzNodeRewardToken: FizzNodeRewardTokenMainnet,
    usdt: USDTMainnet,
    usdc: USDCMainnet,
    uspon: uSPONMainnet,
    spon: SPONMainnet,
  },
};
